import React, { useEffect, useState } from "react";
import { Box, Stack } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import GlobalWrapper from "../../components/Wrapper/GlobalWrapper";
import CompanyCard from "./CompanyCard";

const MUEIDashboard = () => {
  const dispatch = useDispatch();
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;

  return (
    <GlobalWrapper title={"MUEI Dashboard"}>
      <Box sx={{ width: "100%", padding: 0 }}>
        <CompanyCard />
      </Box>
    </GlobalWrapper>
  );
};

export default MUEIDashboard;
